import { render } from "./Lease.vue?vue&type=template&id=2a3704c3"
import script from "./Lease.vue?vue&type=script&lang=js"
export * from "./Lease.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__